import React from 'react';
import { Layout } from 'antd';

const { Footer } = Layout;
function AppFooter() {
  return (<Footer style={{ textAlign: 'center' }}>Copyright ©2020</Footer>);
}

export default AppFooter;
